import { createStyles, makeStyles, Theme } from '@material-ui/core';
import React, { useEffect } from 'react';
import notFoundImg from '../../../Assets/404-page-not-found.png';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            //left:'33%',
            position: 'relative',
            textAlign: 'center',
        },
        img: {
            width: '30%',
        },
        paragraphSorry: {
            fontSize: '60px',
            marginTop: '0px',
            // marginLeft:"12%",
            marginBottom: '13px',
            fontFamily: 'serif',
        },
        paragraphText: {
            fontSize: '30px',
            marginTop: '0px',
            // marginLeft:"7%",
            fontFamily: 'serif',
        },
        span: {
            color: '#e02c16',
        },
    }),
);

const NotFound = () => {
    const styles = useStyles();
    return (
        <>
            <div className={styles.container}>
                <img className={styles.img} src={notFoundImg} alt="Not Found" />
                <div>
                    <p className={styles.paragraphSorry}>
                        <b> Sorry!</b>{' '}
                    </p>
                </div>
                <p className={styles.paragraphText}>
                    {' '}
                    Page <span className={styles.span}>{window.location.pathname}</span> not found
                </p>
            </div>
        </>
    );
};

export default NotFound;
